import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  title: '',
  contentText: '',
  size: 'sm',
  hideOkButton: false
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    openAlertDialog: (state, action) => {
      const { title, contentText, size, hideOkButton } = action.payload;
      state.open = true;
      state.title = title;
      state.contentText = contentText;
      state.size = size || state.size;
      state.hideOkButton = !!hideOkButton;
    },
    closeAlertDialog: (state) => {
      state.open = false;
      state.hideOkButton = false;
    }
  }
});

export const { closeAlertDialog, openAlertDialog } = alertSlice.actions;

export default alertSlice.reducer;
